import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useCommissionsListFilterFields } from '../hooks/useCommissionsListFilterFields';

export const CommissionsListFilterChips: React.FC = () => {
  const fields = useCommissionsListFilterFields();

  return <FilterChips fields={fields} />;
};
